import { useEffect, useState } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { WineInfo } from '../../Model/types';
import { fetchWineById } from '../../Services/WineService'
import './WineInfoPage.css';
import Button from '../../Components/Button/Button';
import { FaArrowLeft } from "react-icons/fa";

const WineInfoPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [wineInfo, setWineInfo] = useState<WineInfo | null>(null);

  useEffect(() => {
    if (id) {
      fetchWineById(parseInt(id)).then(setWineInfo).catch(console.error);   
    }}, [id]);

  if (!wineInfo) return <div className="wine-info-loading">Cargando vino...</div>;

  return (
    <div>
      <Button
        text="volver"
        Icon={FaArrowLeft}
        onClick={() => navigate(-1) }
        size="small"
      />
      <div className="wine-info-container">
        <div className="wine-media">
          <img className='wine-image' src={wineInfo.imageUrl} alt={wineInfo.name} />
          {wineInfo.isSoldOut && (
            <img
              className="sold-out-badge"
              src="/Image/agotado.png"
              alt="Agotado temporalmente"
            />
          )}
        </div>
        <div className="wine-info-details">
          <h2 className="wine-info-name" >{wineInfo.name}</h2>
          <p className="wine-info-country">{`Producido en: ${wineInfo.country}`}</p>
          <p className="wine-info-grape">{`Variedad de uva: ${wineInfo.grape}`}</p>
          <p>{wineInfo.description}</p>
        </div>
        {wineInfo.purchaseUrl && !wineInfo.isSoldOut && (
          <Button
            url={wineInfo.purchaseUrl}
            text="COMPRAR"
          />
        )}
        <div className="grey-square">
          <h3 className="title">Información del producto</h3>
          <div className="product-info-grid">
            <div className="info-item">
              <span className="label">Tipo de producto</span>
              <span className="value">{wineInfo.category}</span>
            </div>
            <div className="info-item">
              <span className="label">alc</span>
              <span className="value">{wineInfo.alcoholContent}% vol</span>
            </div>
            <div className="info-item">
              <span className="label">Año de cosecha</span>
              <span className="value">{wineInfo.year}</span>
            </div>
            <div className="info-item">
              <span className="label">Cantidad neta</span>
              <span className="value">{wineInfo.netQuantity}{wineInfo.unitOfMeasurement}</span>
            </div>
            <div className="info-item">
              <span className="label">Variedad de uva</span>
              <span className="value">{wineInfo.grape}</span>
            </div>
            <div className="info-item">
              <span className="label">Color del vino</span>
              <span className="value">{wineInfo.product}</span>
            </div>
          </div>
        </div>
        <div className="grey-square">
          <h3 className="title">INGREDIENTES</h3>
          <p className="ingredients-text"> {wineInfo.ingredientsText}</p>
          <hr className="divider" />
          <p className="atmosphere-note">{wineInfo.ingredientsObs}</p>
        </div>
        <div className="grey-square">
          <h3 className="title">UNIDAD DE CONSUMO</h3>
          <div className="product-info-grid">
            <div className="info-item">
              <span className="label">PORCION(ES)</span>
              <span className="value">{wineInfo.portions1}</span>
            </div>
            <div className="info-item">
              <span className="label">MILILITROS</span>
              <span className="value">{wineInfo.milliliters1}</span>
            </div>
            <div className="info-item">
              <span className="label">PORCION(ES)</span>
              <span className="value">{wineInfo.portions2}</span>
            </div>
            <div className="info-item">
              <span className="label">MILILITROS</span>
              <span className="value">{wineInfo.milliliters2}</span>
            </div>
          </div>
        </div>
        <div className="grey-square">
          <h3 className="title">NUTRITION DECLARATION</h3>
          <div className="nutrition-table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>{wineInfo.text1}</th>
                  <th>{wineInfo.text2}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>energía</td>
                  <td>{wineInfo.energy1}</td>
                  <td>{wineInfo.energy2}</td>
                </tr>
                <tr>
                  <td>grasas</td>
                  <td>{wineInfo.fat1}</td>
                  <td>{wineInfo.fat2}</td>
                </tr>
                <tr>
                  <td className="sub">de las cuales saturadas</td>
                  <td>{wineInfo.ofWhichSaturates1}</td>
                  <td>{wineInfo.ofWhichSaturates2}</td>
                </tr>
                <tr>
                  <td>hidratos de carbono</td>
                  <td>{wineInfo.carbohydrate1}</td>
                  <td>{wineInfo.carbohydrate2}</td>
                </tr>
                <tr>
                  <td className="sub">de los cuales azúcares</td>
                  <td>{wineInfo.ofWhichSugars1}</td>
                  <td>{wineInfo.ofWhichSugars1}</td>
                </tr>
                <tr>
                  <td>proteínas</td>
                  <td>{wineInfo.protein1}</td>
                  <td>{wineInfo.protein2}</td>
                </tr>
                <tr>
                  <td>sal</td>
                  <td>{wineInfo.salt1}</td>
                  <td>{wineInfo.salt1}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="grey-square">
          <h3 className="title">CONSUMO RESPONSABLE</h3>
          <div  className="wine-responsible-image-container" >
            <img className="wine-responsible-image" src='/Image/no_drive.png' alt={`no drive`} />
            <img className="wine-responsible-image" src='/Image/no_pregnant.png' alt={`no pregnant`} />
            <img className="wine-responsible-image" src='/Image/no_under18.png' alt={`no under 18`} />
          </div>
          <p>Beba siempre con moderación.</p>
        </div>
      </div>
    </div>
  );
};

export default WineInfoPage;